import { Button } from '@cian/ui-kit';
import { IconToggleHeartOn16, IconToggleHeartOff16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

interface IFavouriteButtonProps {
  isFavourite: boolean;
  onClick(): void;
}

export const FavouriteButton: React.FC<IFavouriteButtonProps> = ({ isFavourite, onClick }) => {
  const icon = isFavourite ? <IconToggleHeartOn16 color="error_100" /> : <IconToggleHeartOff16 color="error_100" />;
  const label = isFavourite ? 'В избранном' : 'В избранное';

  return (
    <Button theme="fill_white_secondary" onClick={onClick} beforeIcon={icon} size="XS">
      {label}
    </Button>
  );
};
